import React from "react";
import { Link } from "react-router-dom";

// Geometric shield mark — the AuditVanguard brand vector. Theme-adaptive
// (fill/stroke ride on the foreground/background tokens) and crisp at any size.
export const ShieldMark = ({ className = "w-9 h-9" }) => (
    <svg viewBox="0 0 24 24" className={`shrink-0 ${className}`} aria-hidden="true" focusable="false">
        <path
            d="M12 1.6 20.4 4.8v6.4c0 5.35-3.35 9.3-8.4 11.2-5.05-1.9-8.4-5.85-8.4-11.2V4.8L12 1.6Z"
            className="fill-foreground"
        />
        <text
            x="12"
            y="15.2"
            textAnchor="middle"
            className="fill-background"
            style={{ font: "700 8.5px Georgia, 'Playfair Display', serif", letterSpacing: "-0.4px" }}
        >
            AV
        </text>
    </svg>
);

export const BrandLogo = ({ to = "/", text = "AuditVanguard", className = "" }) => {
    const inner = (
        <>
            <ShieldMark className="w-8 h-8" />
            <span className="font-display text-lg font-semibold tracking-tight truncate">
                {text}
            </span>
        </>
    );
    const cls = `flex items-center gap-2.5 min-w-0 ${className}`;
    if (!to) {
        return (
            <div className={cls} data-testid="brand-logo">
                {inner}
            </div>
        );
    }
    return (
        <Link to={to} className={cls} data-testid="brand-logo">
            {inner}
        </Link>
    );
};
